/** Exactly one of: the failure, the spinner, or the queue. */
import type { WorkshopShell } from '../../dashboards/workshopDetailUrlFor';
import { ReviewError, ReviewLoading } from '../ReviewLoadStates';
import type { useReviewQueueState } from '../useReviewQueueState';

import ReviewQueueDesktopBody from './ReviewQueueDesktopBody';
import ReviewQueuePhoneBody from './ReviewQueuePhoneBody';

export default function ReviewQueueBody({
  s,
  isPhone,
  shell,
}: {
  s: ReturnType<typeof useReviewQueueState>;
  isPhone: boolean;
  shell: WorkshopShell;
}) {
  if (s.error) return <ReviewError message={s.error} onRetry={s.reload} />;
  // ONLY the first load blanks the page. A refetch — which is what every view
  // toggle is — keeps the rows and dims them slightly, so the operator does not
  // lose their place every time they tick Show resolved (U7).
  if (s.loading) return <ReviewLoading label="Loading flagged items" />;
  if (isPhone) return <ReviewQueuePhoneBody data={s.data} muted={s.tab === 'resolved'} />;
  return <ReviewQueueDesktopBody data={s.data} showResolved={s.showResolved} shell={shell} />;
}
